"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import { NumberInput, Select } from "@mantine/core";
const DUTY_PER_10ML = 2.2;
const VAT_RATE = 0.2;
const formats = [{
  value: "10",
  label: "10ml nic salt or e-liquid"
}, {
  value: "2",
  label: "2ml prefilled pod"
}, {
  value: "12",
  label: "12ml prefilled kit"
}, {
  value: "20",
  label: "20ml big puff kit"
}, {
  value: "21",
  label: "2 × 10ml twin pack"
}, {
  value: "50",
  label: "50ml shortfill"
}, {
  value: "100",
  label: "100ml shortfill"
}, {
  value: "custom",
  label: "Custom volume"
}];
// const formats = [
//     { value: "10ml", label: "10ml nic salt or e-liquid", volume: 10 },
//     { value: "2ml-pod", label: "2ml prefilled pod", volume: 2 },
//     { value: "12ml", label: "12ml prefilled kit", volume: 12 },
//     { value: "20ml-puff", label: "20ml big puff kit", volume: 20 },
//     { value: "20ml-twin", label: "2 × 10ml twin pack", volume: 20 },
//     { value: "50ml", label: "50ml shortfill", volume: 50 },
//     { value: "100ml", label: "100ml shortfill", volume: 100 },
//     { value: "custom", label: "Custom volume" },
// ];

const money = value => `£${value.toFixed(2)}`;
export default function VapeTaxCalculator() {
  const $ = _c(97);
  const [format, setFormat] = useState("10");
  const [volume, setVolume] = useState(10);
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState(1);
  const ml = Number(volume) || 0;
  let t0;
  if ($[0] !== quantity) {
    t0 = Math.round(Number(quantity) || 1);
    $[0] = quantity;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const units = Math.max(t0, 1);
  const unitPrice = Number(price) || 0;
  const totalMl = ml * units;
  const todayTotal = unitPrice * units;
  const duty = totalMl / 10 * DUTY_PER_10ML;
  const vat = duty * VAT_RATE;
  const added = duty + vat;
  const newTotal = todayTotal + added;
  let t1;
  if ($[2] !== added || $[3] !== duty || $[4] !== ml || $[5] !== newTotal || $[6] !== todayTotal || $[7] !== totalMl || $[8] !== unitPrice || $[9] !== units || $[10] !== vat) {
    t1 = {
      ml,
      units,
      unitPrice,
      totalMl,
      todayTotal,
      duty,
      vat,
      added,
      newTotal
    };
    $[2] = added;
    $[3] = duty;
    $[4] = ml;
    $[5] = newTotal;
    $[6] = todayTotal;
    $[7] = totalMl;
    $[8] = unitPrice;
    $[9] = units;
    $[10] = vat;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  const calculation = t1;
  let t2;
  if ($[12] !== format) {
    t2 = formats.find(item => item.value === format);
    $[12] = format;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const selectedFormat = t2;
  const productName = format === "custom" ? `${calculation.ml}ml product` : selectedFormat?.label || "Product";
  const showError = calculation.ml <= 0 || calculation.unitPrice <= 0;
  let t3;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value => {
      setFormat(value);
      if (value !== "custom") {
        setVolume(Number(value));
      }
    };
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const handleFormatChange = t3;
  let t4;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="m-0 text-xl font-extrabold leading-[1.3] text-[#1F2933]">Calculate any product</h2>;
    t5 = <p className="mb-5 mt-1 text-sm leading-[1.6] text-[#6B7280]">Enter what a pack costs today and how much liquid it holds. The duty figure updates as you type.</p>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t4 = $[15];
    t5 = $[16];
  }
  let t6;
  if ($[17] !== showError) {
    t6 = showError && <p className="mb-3.5 text-[13px] font-semibold text-[#B42318]">Please enter a price and a liquid volume above zero.</p>;
    $[17] = showError;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      label: "mb-1.5 text-[13px] font-bold tracking-[0.3px] text-[#1F2933]",
      input: "text-base"
    };
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== format) {
    t8 = <Select label="Product format" value={format} onChange={handleFormatChange} data={formats} allowDeselect={false} size="md" radius="md" classNames={t7} />;
    $[20] = format;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="mt-1 block text-xs leading-normal text-[#6B7280]">Sets the volume below. Choose custom to type your own.</span>;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8) {
    t10 = <div className="mb-4.5">{t8}{t9}</div>;
    $[23] = t8;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      label: "mb-1.5 text-[13px] font-bold tracking-[0.3px] text-[#1F2933]",
      input: "text-base"
    };
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== volume) {
    t12 = <NumberInput label="Total liquid volume (ml)" value={volume} onChange={setVolume} min={0} placeholder={0} step={0.5} decimalScale={1} size="md" radius="md" classNames={t11} />;
    $[26] = volume;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="mt-1 block text-xs leading-normal text-[#6B7280]">Every millilitre in one pack. A box of ten 10ml bottles is 100ml.</span>;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12) {
    t14 = <div className="mb-4.5">{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      label: "mb-1.5 text-[13px] font-bold tracking-[0.3px] text-[#1F2933]",
      input: "text-base"
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== price) {
    t16 = <NumberInput label={"Price today (\xA3)"} value={price} onChange={setPrice} min={0} step={0.01} decimalScale={2} fixedDecimalScale={false} placeholder="e.g. 2.49" size="md" radius="md" classNames={t15} />;
    $[32] = price;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="mt-1 block text-xs leading-normal text-[#6B7280]">Your trade cost or shelf price, whichever you want to work from.</span>;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t16) {
    t18 = <div className="mb-4.5">{t16}{t17}</div>;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      label: "mb-1.5 text-[13px] font-bold tracking-[0.3px] text-[#1F2933]",
      input: "text-base"
    };
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== quantity) {
    t20 = <NumberInput label="Quantity" value={quantity} onChange={setQuantity} min={1} step={1} size="md" radius="md" classNames={t19} />;
    $[38] = quantity;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="mt-1 block text-xs leading-normal text-[#6B7280]">Number of packs, or units in the case you are ordering.</span>;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t20) {
    t22 = <div>{t20}{t21}</div>;
    $[41] = t20;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t10 || $[44] !== t14 || $[45] !== t18 || $[46] !== t22 || $[47] !== t6) {
    t23 = <div className="w-full rounded-2xl border border-[#E3E8EE] bg-white px-5.5 py-6 lg:flex-1">{t4}{t5}{t6}{t10}{t14}{t18}{t22}</div>;
    $[43] = t10;
    $[44] = t14;
    $[45] = t18;
    $[46] = t22;
    $[47] = t6;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="mb-2.5 text-xs font-bold uppercase tracking-[1.2px] text-white/85">Your calculation</div>;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== calculation.units || $[51] !== productName) {
    t25 = <div className="mb-4.5 text-lg font-extrabold leading-[1.4]">{productName} × {calculation.units}</div>;
    $[50] = calculation.units;
    $[51] = productName;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== calculation.todayTotal) {
    t26 = money(calculation.todayTotal);
    $[53] = calculation.todayTotal;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t26) {
    t27 = <ResultRow label="Price today" value={t26} />;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  const t28 = `${calculation.totalMl} ml`;
  let t29;
  if ($[57] !== t28) {
    t29 = <ResultRow label="Liquid volume taxed" value={t28} />;
    $[57] = t28;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== calculation.duty) {
    t30 = money(calculation.duty);
    $[59] = calculation.duty;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t30) {
    t31 = <ResultRow label="Vaping Products Duty" value={t30} />;
    $[61] = t30;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== calculation.vat) {
    t32 = money(calculation.vat);
    $[63] = calculation.vat;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t32) {
    t33 = <ResultRow label="VAT on the duty (20%)" value={t32} />;
    $[65] = t32;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== calculation.added) {
    t34 = money(calculation.added);
    $[67] = calculation.added;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t34) {
    t35 = <ResultRow label="Total duty added" value={t34} />;
    $[69] = t34;
    $[70] = t35;
  } else {
    t35 = $[70];
  }
  let t36;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div className="mb-1.5 text-xs font-extrabold uppercase tracking-[1px] text-[#6B7280]">Price from 1 October 2026</div>;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] !== calculation.newTotal) {
    t37 = money(calculation.newTotal);
    $[72] = calculation.newTotal;
    $[73] = t37;
  } else {
    t37 = $[73];
  }
  let t38;
  if ($[74] !== t37) {
    t38 = <div className="text-[38px] font-extrabold leading-none text-primary">{t37}</div>;
    $[74] = t37;
    $[75] = t38;
  } else {
    t38 = $[75];
  }
  let t39;
  if ($[76] !== calculation.newTotal || $[77] !== calculation.unitPrice || $[78] !== calculation.units) {
    t39 = calculation.units > 1 && <div className="mt-2 text-[13px] leading-normal text-[#4B5563]">{money(calculation.newTotal / calculation.units)}{" "}per unit, up from{" "}{money(calculation.unitPrice)}</div>;
    $[76] = calculation.newTotal;
    $[77] = calculation.unitPrice;
    $[78] = calculation.units;
    $[79] = t39;
  } else {
    t39 = $[79];
  }
  let t40;
  if ($[80] !== t38 || $[81] !== t39) {
    t40 = <div className="mt-4.5 rounded-xl bg-white px-4.5 pb-4 pt-4.5 text-center">{t36}{t38}{t39}</div>;
    $[80] = t38;
    $[81] = t39;
    $[82] = t40;
  } else {
    t40 = $[82];
  }
  let t41;
  if ($[83] !== t25 || $[84] !== t27 || $[85] !== t29 || $[86] !== t31 || $[87] !== t33 || $[88] !== t35 || $[89] !== t40) {
    t41 = <div className="w-full rounded-2xl bg-linear-to-br from-primary via-primary/80 to-primary/60 px-5.5 py-6.5 text-white lg:sticky lg:top-6 lg:flex-[0_1_340px]">{t24}{t25}{t27}{t29}{t31}{t33}{t35}{t40}</div>;
    $[83] = t25;
    $[84] = t27;
    $[85] = t29;
    $[86] = t31;
    $[87] = t33;
    $[88] = t35;
    $[89] = t40;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== t23 || $[92] !== t41) {
    t42 = <div className="flex flex-col gap-4.5 lg:flex-row lg:items-start">{t23}{t41}</div>;
    $[91] = t23;
    $[92] = t41;
    $[93] = t42;
  } else {
    t42 = $[93];
  }
  let t43;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <p className="mt-4.5 text-[12.5px] leading-[1.65] text-[#6B7280]">Duty is charged at £2.20 per 10ml of vaping liquid, with 20% VAT applied on the duty, so £2.64 is added per 10ml. Figures estimate the duty component only. Final retail pricing is set by suppliers and may also move with RRP changes, packaging redesigns and duty stamp costs. Based on the official rate in the{" "}<a href="https://www.gov.uk/government/publications/introduction-of-vaping-products-duty-from-1-october-2026/introduction-of-vaping-products-duty-from-1-october-2026" target="_blank" rel="noopener noreferrer" className="font-semibold text-primary hover:underline">HMRC Vaping Products Duty policy paper</a>.</p>;
    $[94] = t43;
  } else {
    t43 = $[94];
  }
  let t44;
  if ($[95] !== t42) {
    t44 = <div className="mx-auto w-full max-w-6xl p-1">{t42}{t43}</div>;
    $[95] = t42;
    $[96] = t44;
  } else {
    t44 = $[96];
  }
  return t44;
}
function ResultRow(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span>{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <strong className="whitespace-nowrap font-bold text-white">{value}</strong>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex justify-between gap-3 border-b border-white/20 py-2.25 text-[14.5px] leading-[1.6] text-white/90">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}